import * as React from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { Formatter } from 'utils';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';
import { Skeleton } from 'components/ui/skeleton';
import { cn } from 'lib/utils';

import { useToggleValuesVisibilityStore } from './toggle-values-visibility-store';
import { Heading } from './ui-kit';

type Props = React.ComponentProps<'div'>;

export const ListHeader = ({ className, ...props }: Props) => {
  const { invoice } = useInvoiceStore();
  const { visible, toggleVisibility } = useToggleValuesVisibilityStore();

  const ToggleIcon = visible ? EyeOffIcon : EyeIcon;

  const totalValue = React.useMemo(() => {
    if (!invoice?.items?.length) return '---';

    const total = invoice.items.reduce((acc, cur) => {
      return acc + cur.prodVprod;
    }, 0);

    return Formatter.currency(total);
  }, [invoice?.items]);

  const netWeight = React.useMemo(() => {
    if (!invoice?.volume?.transpvol_peso_l) return '---';
    return Formatter.weight(invoice.volume.transpvol_peso_l);
  }, [invoice?.volume?.transpvol_peso_l]);

  const grossWeight = React.useMemo(() => {
    if (!invoice?.volume?.transpvol_peso_b) return '---';
    return Formatter.weight(invoice.volume.transpvol_peso_b);
  }, [invoice?.volume?.transpvol_peso_b]);

  const totalVolume = React.useMemo(() => {
    if (!invoice?.volume?.transpvol_q_vol) return '---';
    return invoice.volume.transpvol_q_vol;
  }, [invoice?.volume?.transpvol_q_vol]);

  if (!invoice) {
    return (
      <div {...props} className={cn('flex justify-between gap-4', className)}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Heading key={index}>
            <Heading.Title><Skeleton className={'w-20 h-[14px]'} /></Heading.Title>
            <Heading.Content><Skeleton className={'w-40 h-6'} /></Heading.Content>
          </Heading>
        ))}
      </div>
    );
  }

  return (
    <div {...props} className={cn('flex justify-between gap-4', className)}>
      <Heading>
        <Heading.Title>Valor total</Heading.Title>
        <Heading.Content>
          {visible && totalValue || '********'}
          <button onClick={toggleVisibility}><ToggleIcon className={'w-4 h-4'} /></button>
        </Heading.Content>
      </Heading>
      <Heading>
        <Heading.Title>Peso líquido</Heading.Title>
        <Heading.Content>{netWeight}</Heading.Content>
      </Heading>
      <Heading>
        <Heading.Title>Peso bruto</Heading.Title>
        <Heading.Content>{grossWeight}</Heading.Content>
      </Heading>
      <Heading>
        <Heading.Title>Volume</Heading.Title>
        <Heading.Content>{totalVolume}</Heading.Content>
      </Heading>
    </div>
  );
};